import { Component, OnInit } from '@angular/core';
import { SharedToolsService } from '@huge-monorepo/shared/tools';
import { DialogService } from '@huge-monorepo/shared/services';
import { HeaderComponent, HeaderConfig } from '@huge-monorepo/shared/components';
import { NavigationTabConfig } from '@huge-monorepo/shared/components';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TeltonikaDeviceGeneralComponent } from "./teltonika-device-general/teltonika-device-general.component";
import { TeltonikaDeviceRemoteAccessComponent } from "./teltonika-device-remote-access/teltonika-device-remote-access.component";
import { TeltonikaDeviceMetricsComponent } from "./teltonika-device-metrics/teltonika-device-metrics.component";
import { TeltonikaDeviceDataUsageComponent } from "./teltonika-device-data-usage/teltonika-device-data-usage.component";
import { TeltonikaDevicePortsComponent } from "./teltonika-device-ports/teltonika-device-ports.component";
import { TeltonikaDeviceReportingComponent } from "./teltonika-device-reporting/teltonika-device-reporting.component";
import { TeltonikaDeviceLocationComponent } from './teltonika-device-location/teltonika-device-location.component';
import { TeltonikaDeviceMonitoringComponent } from './teltonika-device-monitoring/teltonika-device-monitoring.component';
import { TeltonikaDevice } from '@huge-monorepo/shared/interfaces';
import { TeltonikaDeviceTroubleShootingComponent } from "./teltonika-device-trouble-shooting/teltonika-device-trouble-shooting.component";
import { TeltonikaDeviceOtherServicesComponent } from './teltonika-device-other-services/teltonika-device-other-services.component';
import { TeltonikaSelectTagModalComponent } from '../modals/teltonika-select-tag-modal/teltonika-select-tag-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TeltonikaUpdateNameModalComponent } from '../modals/teltonika-update-name-modal/teltonika-update-name-modal.component';
import { TeltonikaDeviceAuditingComponent } from './teltonika-device-auditing/teltonika-device-auditing.component';
import { BehaviorSubject, filter } from 'rxjs';
import { TeltonikaUpdateCredentialsModalComponent } from '../modals/teltonika-update-credentials-modal/TeltonikaUpdateCredentialsModal.component';
import { YesNoModalComponent } from '@huge-monorepo/shared/tools';
import { TeltonikaIpListModalComponent } from '../modals/teltonika-ip-list-modal/teltonika-ip-list-modal.component';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';
import { TeltonikaExecuteTaskModalComponent } from '../modals/teltonika-execute-task-modal/TeltonikaExecuteTaskModal.component';
import { TeltonikaTaskPollingModalComponent } from '../modals/teltonika-task-polling-modal/teltonika-task-polling-modal.component';
import { TeltonikaTaskState } from '@huge-monorepo/shared/interfaces';
import {
  TeltonikaUpdateDeviceModalComponent
} from '../modals/teltonika-update-device-modal/teltonika-update-device-modal.component';
import { GenericButtonModalComponent } from '@huge-monorepo/shared/modals';
import { SideNavToggleService } from '@huge-monorepo/hip/services';
@Component({
  selector: 'teltonika-track-device',
  templateUrl: './teltonika-device.component.html',
  styleUrls: ['./teltonika-device.component.scss'],
  standalone: true,
  imports: [HeaderComponent, ToolsModule, MaterialModule, RouterModule, TeltonikaDeviceGeneralComponent, TeltonikaDeviceAuditingComponent, TeltonikaDeviceRemoteAccessComponent, TeltonikaDeviceMetricsComponent, TeltonikaDeviceDataUsageComponent, TeltonikaDeviceLocationComponent, TeltonikaDevicePortsComponent, TeltonikaDeviceReportingComponent, TeltonikaDeviceMonitoringComponent, TeltonikaDeviceTroubleShootingComponent, TeltonikaDeviceOtherServicesComponent]
})
export class TeltonikaDeviceComponent implements OnInit {
  teltonikaService = this.sharedTeltonikaService.getService();
  isHIP = this.sharedTeltonikaService.getIsHIP();
  currentTab: TabOption = this.isHIP ? 'General' : 'Data Usage';
  displayHeader: boolean = false;
  list: {} = {
    Heading: 'Teltonika Menu',
    Items: [],
  };

  dbFetchError: boolean = false;
  deviceFetchError: boolean = false;

  changeTab(tab: string): void {
    this.currentTab = tab as TabOption;
  }

  id = -1;

  private deviceSims = new BehaviorSubject<any[] | null>(null);

  private deviceName?: string;
  private deviceSerial?: string;

  deviceHeaderData: HeaderConfig;
  headerData: HeaderConfig;
  activeSim: string;

  tabConfig: NavigationTabConfig[] = [
    ...(this.isHIP ? [
      { title: 'General', },
      { title: 'Remote Access', },
      { title: 'Metrics', },
      { title: 'Data Usage', },
      { title: 'Location', },
      { title: 'Ports', },
      { title: 'Troubleshooting', },
      ...(this.isHipTeltonikaAdmin() ? [{ title: 'Auditing', }] : []),
      // { title: 'Monitoring', },
      { title: 'Reporting', },
      ...(this.isHipTeltonikaAdmin() ? [{ title: 'Other Services' }] : []),
    ] : [
      ...(this.teltonikaService.isTeltonikaRemoteAccess() ? [{ title: 'Remote Access' }] : []),
      { title: 'Data Usage', },
      { title: 'Metrics', },
      { title: 'Location', },
      { title: 'Ports', },
      { title: 'Reporting', },
      { title: 'Other Services' }
    ]),

  ];

  RecentDeviceFilesData = undefined

  RecentTaskManagerLogsData = undefined

  ConfigurationLogsData = undefined

  preselectedTab = 0;

  isString(value): value is string {
    return typeof value === 'string';
  }

  navLoading: boolean = true;
  wanSchedulerEnabled: boolean = false;
  
  constructor(
    private route: ActivatedRoute,
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private router: Router,
    private tools: SharedToolsService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private toastr: ToastrService,
    private sideNavToggleService: SideNavToggleService,
  ) { }

  ngOnInit() {
    this.navLoading = false;
    let resData = undefined;
    this.route.paramMap.subscribe(
      (paraMap: any) => {
        if (paraMap.params.id) {
          let id = paraMap.params.id;
          this.id = id;
          this.fetchData(id);
        }


        if (paraMap.params.tab) {
          this.currentTab = decodeURIComponent(paraMap.params.tab) as TabOption;
          this.preselectedTab = this.tabConfig.findIndex((tab) => tab.title === this.currentTab);
        }
      }
    );
  }

  fetchData(id: number, opn?: boolean) {
    this.displayHeader = false;
    this.deviceSims = new BehaviorSubject<any[] | null>(null);
    this.headerData = { details: {} };
    this.deviceHeaderData = { details: {} };

    this.teltonikaService.getDeviceByID(id, true, opn, 0).subscribe({
      next: (res: TeltonikaDevice) => {
        this.formatDataFromDB(res);
      },
      error: (err) => {
        console.error(err);
        this.dbFetchError = true;
        this.toastr.error('Error Fetching Device Data from DB');
      }
    });

    this.teltonikaService.getDeviceByID(id, false, opn, 0).subscribe({
      next: (res: TeltonikaDevice) => {
        this.formatDataFromDevice(res);
      },
      error: (err) => {
        console.error(err);
        this.deviceFetchError = true;
        this.toastr.error('Error Fetching Device Data: Device May Be Offline');
      }
    });
    this.preselectedTab = this.tabConfig.findIndex((tab) => tab.title === this.currentTab);
  }

  rebootDevice() {
    const dialogRef = this.dialog.open(YesNoModalComponent, {
      width: '700px',
      data: {
        Heading: 'Reboot Device?',
        Message: 'Are you sure that you would like to reboot this device?',
      },
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result !== null) {
        if (result === true) {
          this.teltonikaService.rebootDevices([+this.id]).subscribe({
            next: (res) => {
              this.fetchData(this.id, true);
            },
            error: (err) => {
              console.error(err);
              this.toastr.error(`Error Rebooting Device: ${this.id}`);
            }
          });
        }
      }
    });
  }

  executeTask() {
    const dialogRef = this.dialog.open(TeltonikaExecuteTaskModalComponent, {
      width: '500px',
      maxHeight: '600px',
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result != null) {
        if (result.TaskID == null) {
          return;
        } else {
          this.teltonikaService.executeTeltonikaTask(result.TaskID, [+this.id]).subscribe({
            next: (resp) => {
              const sessionGuid = resp.SessionGUID

              this.toastr.success('Task is being executed');

              const dialogRef = this.dialog.open(TeltonikaTaskPollingModalComponent, {
                width: '60vw',
                data: { sessionGuid: sessionGuid, taskId: result.TaskID, devices: [{ Name: this.deviceName, ID: +this.id, Serial: this.deviceSerial, Status: TeltonikaTaskState.loading }] }
              });

              this.dialogService.RegisterDialog(dialogRef);
              dialogRef.afterClosed().subscribe((result) => {
                this.dialogService.DeRegisterDialog(dialogRef);
              });
            },
            error: (err) => {
              this.toastr.error('Error starting execution');
            }
          });
        }
      }
    });
  }

  swapSim() {
    this.teltonikaService.switchSim(this.id).subscribe({
      next: (resp) => {
        this.fetchData(this.id, true);
        this.toastr.success('Sim Swap command sent');
      },
      error: (err) => {
        this.toastr.error('Error Swapping Sim');
      }
    });
  }

  reloadDataSender(currentIP: string) {
    const dialogRef = this.dialog.open(TeltonikaUpdateDeviceModalComponent, {
      width: '500px',
      height: '70vh',
      data: {
        SingleDevice: true,
        IP: currentIP,
        Username: 'admin',
        FTPPort: 22,
        FTPUsername: 'root',
      }
    });
    this.dialogService.RegisterDialog(dialogRef);

    dialogRef.afterClosed().subscribe((result: 'success' | null) => {
      this.dialogService.DeRegisterDialog(dialogRef);

      if (result === 'success') {
        this.toastr.success('Updated Device');
        // Optionally refresh a view or reload data here
      }
    });
  }

  selectTag(p) {
    const dialogRef = this.dialog.open(TeltonikaSelectTagModalComponent, {
      width: '700px'
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result != null) {
        if (result != false) {
          this.displayHeader = false;
          this.teltonikaService.upsertExtraInfo({ DeviceIDs: [p.id], Name: p.TeltonikaCustomName, NewTagID: result }).subscribe({
            next: (resp) => {
              this.fetchData(this.id, true);
              this.toastr.success('Device Tag Updated');
            },
            error: (err) => {
              this.fetchData(this.id, true);
              this.toastr.error('Error updating device tag');
            }
          });
        }
      }
    });
  }

  updateCredentials() {
    const dialogRef = this.dialog.open(TeltonikaUpdateCredentialsModalComponent, {
      width: '500px'
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result != null) {
        if (result != false) {
          this.teltonikaService.updateCredentials(this.id, result.username, result.password).subscribe({
            next: (resp) => {
              this.fetchData(this.id, true);
              this.toastr.success('Device Credentials Updated');
            },
            error: (err) => {
              this.toastr.error('Error updating device credentials');
            }
          });
        }
      }
    });
  }

  viewIps(vpnIP?: string, standardCheckInIPs?: string[], activeIp?: string) {
    let ips: string[] = [];
    if (vpnIP) {
      ips.push(vpnIP);
    }
    if (standardCheckInIPs) {
      ips.push(...standardCheckInIPs);
    }
    const dialogRef = this.dialog.open(TeltonikaIpListModalComponent, {
      width: '500px',
      data: { ips: ips, activeIp: activeIp }
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
    });
  }

  updateName(p) {
    const dialogRef = this.dialog.open(TeltonikaUpdateNameModalComponent, {
      width: '700px',
      data: { currentName: p.TeltonikaCustomName }
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result != null) {
        if (result.Name != null) {
          this.displayHeader = false;
          let devId = null;
          if (p.TeltonikaTag) {
            devId = p.TeltonikaTag.ID ?? null;
          }
          this.teltonikaService.upsertExtraInfo({ DeviceIDs: [p.id], Name: result.Name, NewTagID: devId }).subscribe({
            next: (resp) => {
              this.fetchData(this.id, true);
              this.toastr.success('Device Name Updated');
            },
            error: (err) => {
              this.fetchData(this.id, true);
              this.toastr.error('Error updating device Name');

            }
          });
        }
      }
    });
  }

  openRecoveryModal() {
    const dialogRef = this.dialog.open(GenericButtonModalComponent, {
      width: '700px',
      data: { Buttons: ["SSH Recovery", "HTTPS Recovery"] }
    });
    this.dialogService.RegisterDialog(dialogRef);
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogService.DeRegisterDialog(dialogRef);
      if (result != null) {
        if (this.isHIP) {
          if (this.sideNavToggleService.openOrClosed()) {
            this.sideNavToggleService.toggle();  // close before opening tab
          }
        }

        if (result == "HTTPS Recovery") {
          window.open(this.router.serializeUrl(this.router.createUrlTree(["/Teltonika/recovery/", this.id], { queryParams: { method: "HTTP" } })), '_blank')
        } else {
          window.open(this.router.serializeUrl(this.router.createUrlTree(["/Teltonika/recovery/", this.id], { queryParams: { method: "SSH" } })), '_blank')
        }
        this.sideNavToggleService.toggle();
      }
    });
  }

  formatDataFromDB(res: TeltonikaDevice) {
    if (!res) {
      return;
    }
    let tempHeader: any = {};
    tempHeader["details"] = {}
    tempHeader["actionHolder"] = {}

    let dotColor = "grey";
    switch (res.CDRDeviceInfo.TeltonikaStatus) {
      case "Offline":
        dotColor = "red";
        break;
      case "Online":
        dotColor = "green";
        break;
      case "Action Required":
        dotColor = "orange";
        break;
    }

    let tooltipText = '';
    tooltipText += 'Status: ' + `${res.CDRDeviceInfo.TeltonikaStatus ?? 'Unknown'}`;
    if (res.CDRDeviceInfo['TeltonikaStandardCheckInTimestamp']) {
      tooltipText += '\n' + `Last Standard Check-In: ${this.tools.FormatDateTimeFromDateSwedish(this.tools.ParseAPIDateWithTimezone(res.CDRDeviceInfo['TeltonikaStandardCheckInTimestamp']))}`;
    }

    if (res.CDRDeviceInfo['TeltonikaReachableTimestamp']) {
      tooltipText += '\n' + `Last Reachable: ${this.tools.FormatDateTimeFromDateSwedish(this.tools.ParseAPIDateWithTimezone(res.CDRDeviceInfo['TeltonikaReachableTimestamp']))}`;
    }

    if (res.CDRDeviceInfo.TeltonikaCustomName != null) {
      this.deviceName = res.CDRDeviceInfo.TeltonikaCustomName;
    }

    if (res.CDRDeviceInfo.name != null) {
      this.deviceSerial = res.CDRDeviceInfo.name;
    }

    tempHeader.actionHolder = {
      subHeadings: [{ value: res.CDRDeviceInfo.deviceType, position: "above" }],
      heading: { tooltip: tooltipText, dot: dotColor, value: this.isHIP ? [res.CDRDeviceInfo.TeltonikaCustomName ?? "-", { text: "edit", isIcon: true, clickable: true, action: () => { this.updateName(res.CDRDeviceInfo) } }] : res.CDRDeviceInfo.TeltonikaCustomName ?? "-" },
      buttons: [
        {
          color: 'blue',
          icon: 'refresh',
          tooltip: "Refresh Device",
          action: () => this.fetchData(this.id, true),
          visible: true,
        },
        {
          color: 'blue',
          icon: 'sell',
          tooltip: "Select Tag",
          action: () => this.selectTag(res.CDRDeviceInfo),
          visible: this.isHIP && this.isHipTeltonikaAdmin(),
        },
        {
          color: 'blue',
          icon: 'lock',
          tooltip: 'Update Credentials',
          action: () => this.updateCredentials(),
          visible: this.isHIP && this.isHipTeltonikaAdmin(),
        },
        {
          color: 'blue',
          icon: 'vpn_key',
          tooltip: 'View IPs',
          action: () => this.viewIps(res.CDRDeviceInfo.TeltonikaVPNIP, res.CDRDeviceInfo.StandardCheckInIPs, res.CDRDeviceInfo.LastIP),
          visible: true,
        },
        {
          color: 'blue',
          icon: 'restart_alt',
          tooltip: "Reboot Device",
          action: () => this.rebootDevice(),
          visible: this.isHIP || this.isPortalTeltonikaAdmin(),
        },
        {
          color: 'blue',
          icon: 'terminal',
          tooltip: 'Execute Task',
          action: () => this.executeTask(),
          visible: this.isHIP && this.isHipTeltonikaAdmin(),
        },
        {
          color: 'blue',
          icon: 'swap_horiz',
          tooltip: 'Switch Current SIM',
          action: () => this.swapSim(),
          visible: this.isHIP || this.isPortalTeltonikaAdmin(),
        },
        {
          color: 'blue',
          icon: 'build',
          tooltip: 'Recovery',
          action: () => this.openRecoveryModal(),
          visible: this.isHIP && this.isHipTeltonikaAdmin()
        },
        {
          color: 'blue',
          icon: 'settings_backup_restore',
          tooltip: 'Reload Data Sender',
          action: () => this.reloadDataSender(res.CDRDeviceInfo.LastIP),
          visible: this.isHIP && this.isHipSuperUser(),
        },
        {
          color: 'blue',
          icon: 'cached',
          tooltip: 'Check Firmware',
          action: () => this.checkFirmware(),
          visible: this.isHIP && this.isHipTeltonikaAdmin(),
        }
      ]
    };


    // TODO: use the objects at the bottom of the file, I just want to get this working first
    let sims: any[] = [];

    if (res.CDRDeviceInfo.sims != null) {
      res.CDRDeviceInfo.sims.forEach((sim: any, index: number) => {

        let signalStrengthPath: string = "../assets/Teltonika/connection_signal 2 bar.svg"
        switch (sim.SignalStrengthIndicator) {
          case "Excellent":
            signalStrengthPath = "../assets/Teltonika/connection_signal full bar.svg";
            break;
          case "Good":
            signalStrengthPath = "../assets/Teltonika/connection_signal 3 bar.svg";
            break;
          case "Fair":
            signalStrengthPath = "../assets/Teltonika/connection_signal 2 bar.svg";
            break;
          case "Poor":
            signalStrengthPath = "../assets/Teltonika/connection_signal 1 bar.svg";
            break;
          case "No Signal":
            signalStrengthPath = "../assets/Teltonika/connection_signal empty.svg";
            break;
        }
        sims.push({
          path: "", height: '35px', width: '35px', popover: [
            {
              heading: [
                `Sim: ${sim.name}`,
                {
                  path: signalStrengthPath,
                  height: '30px',
                  width: '25px',
                }]
            },
            {
              "Sim Cell": sim.SimCell,
              Network: sim.Network,
              Disabled: sim.Disabled ? "Yes" : "No",
              SignalStrength: sim.SignalStrength == null ? "Unknown" : sim.SignalStrength + " dBm",
            },
            {
              text: 'Go to Details',
              icon: 'open_in_new',
              action: () => this.router.navigate(['/Devices/List/Details'], { queryParams: { ID: this.id } }),
            }]
        });
      });
      var orderArray = ['mtn', 'vodacom', 'telkom'];

      //sort by mtn, vodacom then telkom
      sims.sort((a, b) => {
        // return orderArray.indexOf(a.popover[1].Network ?? "") - orderArray.indexOf(b.popover[1].Network ?? "");
        const indexA = orderArray.findIndex(order => a.popover[1].Network.toLowerCase().includes(order.toLowerCase()));
        const indexB = orderArray.findIndex(order => b.popover[1].Network.toLowerCase().includes(order.toLowerCase()));
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        return indexA === -1 ? 1 : indexB === -1 ? -1 : 0;
      });
    } else if (res.CDRDeviceInfo.sims == null && !this.isHIP) {
      // Since we can't get data usage for the device, we need to set current tab to Metrics and remove Data Usage option from tabConfig
      this.currentTab = 'Metrics';
      this.tabConfig = this.tabConfig.filter(tab => {
        return tab.title != 'Data Usage';
      })
    }

    tempHeader.details["General Information"] = {}
    if (this.isHIP) {
      if (res.CDRDeviceInfo.TeltonikaTag != null) {
        tempHeader.details['General Information']['Tag'] = res.CDRDeviceInfo.TeltonikaTag.Name;
      } else {
        tempHeader.details['General Information']['Tag'] = '-';
      }
    }
    tempHeader.details['General Information']["Customer Ref"] = res.CDRDeviceInfo.customerReference;
    tempHeader.details["General Information"]["MAC"] = res.CDRDeviceInfo.MACAddress;
    tempHeader.details["General Information"]["Serial"] = res.CDRDeviceInfo.name;
    tempHeader.details["General Information"]["Firmware"] = res.CDRDeviceInfo.TeltonikaFirmware;
    tempHeader.details["General Information"]["IMEI"] = res.CDRDeviceInfo.IMEI;


    tempHeader.details["Network Information"] = {};

    //This will be the converted VPN Uptime from seconds to days, hours, minutes, seconds if it exists. Set to null initially to ensure this variable can be assigned to the header data
    let convertedVPNUptime: string | null = null;
    if (res.CDRDeviceInfo.VpnUptime != null) {
      //VpnUptime is from an epoch time in seconds
      //Need to take the current epoch (in seconds) and subtract the VpnUptime to get the amount of time the VPN has been up
      let currentEpoch = Math.ceil(Date.now() / 1000);  //using ceil to round up to the nearest second
      let vpnUptime = currentEpoch - res.CDRDeviceInfo.VpnUptime;
      convertedVPNUptime = this.convertFromSecondsToDHMS(vpnUptime);
    }

    tempHeader.details["Network Information"]["VPN Uptime"] = convertedVPNUptime;
    tempHeader.details["Network Information"]["VPN Last Updated"] = res.CDRDeviceInfo.VpnLastUpdated != null ? this.tools.FormatDateTimeFromDateSwedish(this.tools.ParseAPIDateWithTimezone(res.CDRDeviceInfo.VpnLastUpdated)) : null;
    tempHeader.details["Network Information"]["VPN IP"] = res.CDRDeviceInfo.VpnIp;
    tempHeader.details["Network Information"]["Connection Type"] = null;
    tempHeader.details["Network Information"]["WAN IP"] = null;
    tempHeader.details["Network Information"]["Ports"] = null;
    tempHeader.details["Network Information"]["Sim (Current)"] = null;
    tempHeader.details["Network Information"]["SIMs"] = null;

    tempHeader.OrderFunctions = {};
    tempHeader.OrderFunctions["Network Information"] = (a: any, b: any) => {
      const order = ["VPN Uptime", "VPN Last Updated", "VPN IP", "Ports", "Connection Type", "WAN IP", "Sim (Current)", "SIMs"];
      const indexA = order.indexOf(a.key);
      const indexB = order.indexOf(b.key);
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }
      return indexA === -1 ? 1 : indexB === -1 ? -1 : 0;
    };

    tempHeader.details["Specific Information"] = {};
    tempHeader.details["Specific Information"]["CPU Usage"] = null;
    tempHeader.details["Specific Information"]["Model"] = null;
    tempHeader.details["Specific Information"]["Manufacturer"] = null;
    tempHeader.details["Specific Information"]["RAM Usage"] = null;
    tempHeader.details["Specific Information"]["Temperature"] = null;
    tempHeader.details["Specific Information"]["Uptime"] = null;


    this.deviceHeaderData = tempHeader;

    this.headerData = tempHeader;


    this.deviceSims.next(sims);

    this.displayHeader = true;

    this.wanSchedulerEnabled = res.CDRDeviceInfo.WANSchedulerEnabled;
  }

  formatDataFromDevice(res: any) {
    if (!res) {
      return;
    }

    this.activeSim = res.NetworkInfo['ServiceProvider'];
    this.deviceSims.pipe(filter(data => data !== null)).subscribe((sims) => {
      sims?.forEach((sim: any, index: number) => {
        if (sim.popover[1].Network.toLowerCase().includes("mtn") && this.activeSim.toLowerCase().includes("mtn")) {
          sim.path = '../assets/Teltonika/yellow-sim.svg';
          sim.popover[1].Active = "Sim is currently active";

        } else if (sim.popover[1].Network.toLowerCase().includes("vodacom") && this.activeSim.toLowerCase().includes("vodacom")) {
          sim.path = '../assets/Teltonika/red-sim.svg';
          sim.popover[1].Active = "Sim is currently active";
        } else {
          sim.path = '../assets/Teltonika/grey-sim.svg';
          sim.popover[1].Active = "Sim is not currently active";
          sim.popover[0].heading = [sim.popover[0].heading[0]];
        }
      });
      let tempHeader = this.deviceHeaderData;
      tempHeader.details["Network Information"]["SIMs"] = { value: sims, image: true };
      if (this.isHIP) {
        tempHeader.details['General Information'] = { "Tag": tempHeader.details["General Information"]["Tag"], "Customer Ref": tempHeader.details["General Information"]["Customer Ref"], ...res.GeneralInfo };
      } else {
        tempHeader.details['General Information'] = res.GeneralInfo;
      }

      const uptime = res.SpecificInfo.Uptime;
      let formattedUptime: string | null = null;

      if (res.SpecificInfo.Uptime != null) {
        formattedUptime = this.convertFromSecondsToDHMS(+uptime);
      }

      tempHeader.details['Specific Information'] = {
        "RAM Usage": {
          value: `${((res.SpecificInfo.RAMUsage.Used / res.SpecificInfo.RAMUsage.Total) * 100).toFixed(1)}%`,
          hoverValue: `${Number(res.SpecificInfo.RAMUsage.Used / 1_000_000).toFixed(2)}MB / ${Number(res.SpecificInfo.RAMUsage.Total / 1_000_000).toFixed(2)}MB`,
          currentValue: `${((res.SpecificInfo.RAMUsage.Used / res.SpecificInfo.RAMUsage.Total) * 100).toFixed(1)}%`,
        },
        "Model": res.SpecificInfo.ModemInfo.Model,
        "Manufacturer": res.SpecificInfo.ModemInfo.Manufacturer,
        "Temperature": `${res.SpecificInfo.Temperature} °C`,
        "CPU Usage": `${res.SpecificInfo.CPUUsage}%`,
        "Uptime": formattedUptime,
      };

      let portPaths = ['../assets/images/Grey - Port 1.svg', '../assets/images/Grey - Port 2.svg', '../assets/images/Grey - Port 3.svg', '../assets/images/Grey - Port WAN.svg'];
      this.teltonikaService.getPortInfo(this.id).subscribe(portRes => {
        if (portRes.Ports.length > 0) {
          //index cant be declared in the forEach loop because it has to be editable
          let index: number = 0
          // Get the image path for each port
          portRes.Ports.forEach((port: any) => {
            const basePath = '../assets/Teltonika/';
            if (port.Name === 'LAN') {
              // LAN logic uses position
              portPaths[index] = `${basePath}${port.State === 'up' ? 'Green' : 'Grey'} - Port ${port.Position}.svg`;
            } else if (port.Name === 'WAN') {
              // WAN logic
              portPaths[index] = `${basePath}${port.State === 'up' ? 'Green' : 'Grey'} - Port WAN.svg`;
            } else {
              //This handles CPU/WiFi for now
              index--;
            }
            // This is commented out because WIFI shouldn't be displayed for now
            // else if (port.name === 'CPU/WiFi') {
            //   // CPU/WIFI logic
            //   return `${basePath}${port.state === 'up' ? 'Green' : 'Grey'} - Port Wifi.svg`;
            // }
            index++;
          });
        }
        tempHeader.details['Network Information']['Ports'] = {
          value: portPaths.map((path) => ({ path: path, height: '20px', width: '20px' })),
          image: true
        };

        if (sims && sims.length > 0) {
          tempHeader.details['Network Information']['Sim (Current)'] = this.activeSim;
        }

        let signalStrengthPath: string = "../assets/Teltonika/connection_signal 2 bar.svg"
        switch (res.NetworkInfo.SignalQuality) {
          case "Excellent":
            signalStrengthPath = "../assets/Teltonika/connection_signal full bar.svg";
            break;
          case "Good":
            signalStrengthPath = "../assets/Teltonika/connection_signal 3 bar.svg";
            break;
          case "Fair":
            signalStrengthPath = "../assets/Teltonika/connection_signal 2 bar.svg";
            break;
          case "Poor":
            signalStrengthPath = "../assets/Teltonika/connection_signal 1 bar.svg";
            break;
          case "No Signal":
            signalStrengthPath = "../assets/Teltonika/connection_signal empty.svg";
            break;
        }
        sims?.unshift({ path: signalStrengthPath, height: '30px', width: '25px', });
      });

      tempHeader.details['Network Information'] = {
        "SIMs": { value: sims, image: true },
        "Connection Type": res.NetworkInfo['MobileConnectionType'],
        "WAN IP": res.NetworkInfo['SimWANIP'],
        "VPN Uptime": tempHeader.details['Network Information']['VPN Uptime'],
        "VPN Last Updated": tempHeader.details['Network Information']['VPN Last Updated'],
        "VPN IP": tempHeader.details['Network Information']['VPN IP'],
      };

      this.headerData.details['Network Information'] = tempHeader.details['Network Information'];
      this.headerData.details['Specific Information'] = tempHeader.details['Specific Information'];
      this.headerData.details['General Information'] = tempHeader.details['General Information'];

      this.headerData.OrderFunctions = {};
      this.headerData.OrderFunctions["Network Information"] = (a: any, b: any) => {
        const order = ["VPN Uptime", "VPN Last Updated", "VPN IP", "Ports", "Connection Type", "WAN IP", "Sim (Current)", "SIMs"];
        const indexA = order.indexOf(a.key);
        const indexB = order.indexOf(b.key);
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        return indexA === -1 ? 1 : indexB === -1 ? -1 : 0;
      };
      this.displayHeader = true;

    });
  }

  convertFromSecondsToDHMS(input: number) {
    const rounded = Math.round(input);
    const days = Math.floor(rounded / (24 * 3600));
    const hours = Math.floor((rounded % (24 * 3600)) / 3600);
    const minutes = Math.floor((rounded % 3600) / 60);
    const seconds = rounded % 60;
    let output = "";
    if (days > 0) {
      output += `${days} d `;
    }
    if (hours > 0) {
      output += `${hours} h `;
    }
    if (minutes > 0) {
      output += `${minutes} m `;
    }
    output += `${seconds} s`;
    return output;
  }

  isPortalTeltonikaAdmin() {
    return !this.isHIP && this.teltonikaService.isTeltonikaAdmin();
  }

  isPortalTeltonikaReporting() {
    return !this.isHIP && (this.teltonikaService.isTeltonikaAdmin() || this.teltonikaService.isReporting());
  }

  isPortalRemoteAccess(): boolean {
    return this.teltonikaService.isTeltonikaRemoteAccess();
  }

  isHipSuperUser(): boolean {
    return this.teltonikaService.isHipSuperUser();
  }

  isHipTeltonikaAdmin(): boolean {
    return this.teltonikaService.isHipTeltonikaAdmin();
  }

  checkFirmware() {
    this.displayHeader = false;
    this.teltonikaService.checkFirmware(this.id).subscribe({
      next: (res) => {
        if (res != null && res.Firmware != null) {
          this.headerData["details"]["General Information"]["Firmware"] = res.Firmware;
          this.displayHeader = true;
          if (res) {
            this.toastr.success('Device Firmware checked successfully');
          }
        }
      },
      error: (err) => {
        console.error(err);
        this.displayHeader = true;
        this.toastr.error('Error checking device firmware');
      }
    });
  }

}

type TabOption = 'General' | 'Remote Access' | 'Metrics' | 'Data Usage' | 'Location' | 'Ports' | 'Troubleshooting' | "Auditing" | 'Monitoring' | 'Reporting' | 'Other Services';

interface SimPopover {
  heading?: string;
  path?: string;
  height?: string;
  width?: string;
  "Sim Cell"?: string;
  Network?: string;
  Disabled?: string;
  SignalStrength?: string;
}

interface SimItem {
  path: string;
  height: string;
  width: string;
  popover: SimPopover[];
}
